module.exports = {"340302001":"东风街道","340302002":"延安街道","340302003":"治淮街道","340302004":"东升街道","340302005":"解放街道","340302006":"曹山街道","340302100":"长淮卫镇","340302200":"李楼乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340302.json
// module id = 1164
// module chunks = 0